import { AppListLight } from '@/components/applications/app-list.light';
import { ErrorSidePanel } from '@/components/errors';
import { useGetApplications } from '@/hooks/api/applications.hook';
import { type Application } from '@/portal-api.definition';
import { type SkinPageConfig, templates } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(services)/services/_sheet/apps/')({
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
});

interface AppsProps {
  isLoading: boolean;
  apps: Application[];
}

function RouteComponent() {
  const { data: apps, isLoading } = useGetApplications();
  const props: AppsProps = {
    isLoading,
    apps: apps ?? [],
  };
  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: AppsProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <AppListLight apps={props.apps} isLoading={props.isLoading} />,
  };
}
